import { useState } from 'react'
import { Text } from 'ui-kit/typography'
import { SCENARIO_CONNECTORS_LIMIT } from 'routes/constants'
import { ScenarioTemplateExtended } from 'routes/Scenarios/helpers/types'
import { Tooltip } from 'routes/components/Shared/Tooltip'
import clsx from 'clsx'
import classes from './ScenarioConnectors.module.scss'

export const ScenarioConnectors = ({
  className,
  connectors = [],
}: {
  className?: string
  connectors: ScenarioTemplateExtended['connectors']
}) => {
  const [expanded, setExpanded] = useState(false)
  if (!connectors.length) return null

  function toggleExpanded() {
    setExpanded(!expanded)
  }

  const restConnectorsCount =
    connectors.length > SCENARIO_CONNECTORS_LIMIT + 1
      ? connectors.length - SCENARIO_CONNECTORS_LIMIT
      : 0

  const connectorsToShow =
    expanded || connectors.length === SCENARIO_CONNECTORS_LIMIT + 1
      ? connectors
      : connectors.slice(0, SCENARIO_CONNECTORS_LIMIT)

  return (
    <div className={clsx(classes.wrapper, className)}>
      <Text as={'span'} size={'sm'} className={classes.title}>
        Works with:
      </Text>

      <ul className={classes.list}>
        {connectorsToShow.map((connector, index) => {
          return (
            <li className={classes.item} key={index}>
              <Tooltip tooltip={connector.name}>
                <img
                  src={connector.logoUri}
                  alt={connector.name}
                  title={connector.name}
                  width={28}
                  height={28}
                />
              </Tooltip>
            </li>
          )
        })}
        <ToggleItem
          counter={restConnectorsCount}
          expanded={expanded}
          onClick={toggleExpanded}
        />
      </ul>
    </div>
  )
}

function ToggleItem({
  counter,
  expanded,
  onClick,
}: {
  counter: number
  expanded: boolean
  onClick: () => void
}) {
  if (counter === 0) return null
  if (expanded) {
    return (
      <li className={clsx(classes.item, classes.item__count)} onClick={onClick}>
        <Text as={'span'} size={'sm'} className={classes.link}>
          collapse
        </Text>
      </li>
    )
  }
  return (
    <li className={clsx(classes.item, classes.item__count)} onClick={onClick}>
      <Text as={'span'} size={'sm'} className={classes.count}>
        +{counter} &nbsp;
      </Text>
      <Text as={'span'} size={'sm'} className={classes.link}>
        see all
      </Text>
    </li>
  )
}
